import React from "react";
import styled from "styled-components";
import theme from "../../theme";

/**
 * ClickCircle brand mark: an open ring (the "circle" — the loop of
 * impression → click → conversion) broken by a cursor arrow (the "click"),
 * with a lime dot closing the loop.
 */
export const BrandMark = ({ size = 32, tone = "brand" }) => {
  const ring = tone === "light" ? theme.color.onDark : theme.color.brandDark;
  const cursor = tone === "light" ? theme.color.accent : theme.color.brand;
  const dot = tone === "light" ? theme.color.accent : theme.chart[1];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="ClickCircle"
    >
      {/* open ring, gap at the lower right where the cursor breaks through */}
      <path
        d="M31.5 27.8A14 14 0 1 1 34 20"
        stroke={ring}
        strokeWidth="4"
        strokeLinecap="round"
      />
      {/* cursor arrow */}
      <path
        d="M19.4 18.1 30.2 22a.9.9 0 0 1 .06 1.66l-4.03 1.9-1.9 4.03a.9.9 0 0 1-1.66-.06l-3.9-10.8a.9.9 0 0 1 1.13-1.13Z"
        fill={cursor}
      />
      {/* dot closing the loop */}
      <circle cx="34" cy="20" r="3.4" fill={dot} />
    </svg>
  );
};

const Wordmark = styled.span`
  font-size: ${({ $size }) => $size}px;
  font-weight: 700;
  letter-spacing: -0.4px;
  line-height: 1;
  color: ${({ $tone }) =>
    $tone === "light" ? theme.color.onDark : theme.color.brandDark};

  em {
    font-style: normal;
    color: ${({ $tone }) =>
      $tone === "light" ? theme.color.accent : theme.color.brand};
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Logo = ({ size = 32, tone = "brand", wordmark = true }) => (
  <Row>
    <BrandMark size={size} tone={tone} />
    {wordmark && (
      <Wordmark $size={Math.round(size * 0.62)} $tone={tone}>
        Click<em>Circle</em>
      </Wordmark>
    )}
  </Row>
);

export default Logo;
